import { Dispatch, ReactElement, SetStateAction } from 'react';
import { useTranslation } from 'react-i18next';

import { Button } from 'antd';

import { setupAnalytics } from 'utils/analytics';
import { saveGDPRSettings } from 'utils/localStorage';

import { COOKIE_PATH } from 'constants/commons';

import { ReactComponent as CloseIcon } from 'assets/icons/close.svg';

import styles from './PrivacySettings.module.scss';

interface PrivacySettingsProps {
  setVisible: (visible: boolean) => void;
  setGDPR: Dispatch<SetStateAction<boolean>>;
}

const PrivacySettings = ({
  setVisible,
  setGDPR
}: PrivacySettingsProps): ReactElement => {
  const { t } = useTranslation();
  const onAccept = (): void => {
    const settings: any = { A: true, F: true, T: true };
    saveGDPRSettings(settings);
    setGDPR(settings);
    setVisible(false);
    setupAnalytics();
  };

  const onDecline = (): void => {
    const settings: any = { A: false, F: false, T: false };
    saveGDPRSettings(settings);
    setGDPR(settings);
    setVisible(false);
  };

  return (
    <div className={styles.containerSettings}>
      <div className={styles.containerInner}>
        <div className={styles.containerMain}>
          <h3 className={styles.header}>
            {t('privacy.title')}
            <Button type="text" onClick={() => setVisible(false)}>
              <CloseIcon className={styles.closeIcon} />
            </Button>
          </h3>
          <p>
            {t('privacy.message')}{' '}
            <a href={COOKIE_PATH} target="_blank" rel="noreferrer">
              {t('privacy.cookiePolicy')}
            </a>
            .
          </p>
        </div>
        <div className={styles.containerActions}>
          <Button
            type="text"
            className={styles.buttonDecline}
            onClick={onDecline}
          >
            {t('privacy.declineCookies')}
          </Button>
          <Button type="primary" onClick={onAccept}>
            {t('privacy.acceptCookies')}
          </Button>
        </div>
      </div>
    </div>
  );
};

export default PrivacySettings;
